module.exports = {
	"articleTitle1": "Film created by University alum to be screened at Michigan Theatre ...",
	"catImage": "yellowstar.png",
	"totalCats": 2,
	"name": "Michigan Theater",
	"articleLink2": "https://www.michigandaily.com/section/arts/organists-michigan-theater",
	"articleSnippet1": "Dec 15, 2016 ... The Michigan Theatre will be screening “The Pickle Recipe,” a film produced and \nwritten by University of Michigan alum Sheldon Cohn and ...",
	"articleSnippet2": "Mar 23, 2016 ... Even if organ music never does make a significant resurgence, it still holds real \nvalue to the Michigan Theater organists.",
	"totalMisc": 1,
	"articleTitle2": "Inside the mechanical beast: The organists of the Michigan Theater ...",
	"address": "603 E Liberty St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/150928/arts.michigantheater.jpg?itok=W40_D-ta",
			"author": "File Photo",
			"caption": "The Michigan Theater has evolved in many ways since it opened in 1928."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160327/agc.NEW_.ThatBrownShow.3.26.16.971.jpg?itok=Ak5xq9z8",
			"author": "Amelia Cacchione",
			"caption": "Michigan Izzat performs at That Brown Show at the Michigan Theater on Saturday."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160323/AAA_6438.jpg?itok=H79XwQ2x",
			"author": "File Photo",
			"caption": ""
		}
	],
	"position": {
		"lat": 42.279777,
		"lng": -83.742009
	},
	"tips": [
		{
			"text": "There's this really cool employee who will occasionally play the organ before your movie starts.",
			"person": "Erik Forkin"
		}
	],
	"articleLink1": "#",
	"categories": {
		"livemusic": 1,
		"movietheater": 1,
		"datespot": 1,
		"location": 1,
		"entertainment": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/michigantheater.json
// module id = 921
// module chunks = 0